module.exports = __webpack_public_path__ + "static/media/optimizer_Atal_Achievement_Award.c0083af7.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/optimizer_Atal_Achievement_Award.webp
// module id = 355
// module chunks = 0